import React from 'react'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Tour from './pages/Tour'
import Merch from './pages/Merch'
import Music from './pages/Music'

const App: React.FC = () => {
  return (
      <div >
        <Navbar />
        <div id="home"><Home /></div>
        <div id="about"><About /></div>
        <div id="tour"><Tour /></div>
        <div id="merch"><Merch /></div>
        <div id="music"><Music /></div>
        <Footer />
      </div>
  )
}

export default App
